import AUTH from '@/constants/auth';

export default {
  accessToken: localStorage.getItem(AUTH.STORAGE_ACCESS_TOKEN) || '',
  status: localStorage.getItem(AUTH.STORAGE_ACCESS_TOKEN) ? 'success' : '',
  errorType: '',
  errorMessage: '',
};
